import { FunctionComponent } from "react";
import TopMenu from "../shared/top-menu/top-menu";
import Footer from "../shared/footer/footer";
import "./features.scss";
import FeatureMenu from "./feature-menu";
import BuyNowButton from "../shared/buy-now-button/buy-now-button";
import FeaturesOverview from "./features-overview";
import H2 from "../shared/html-tags/h2";
import H1 from "../shared/html-tags/h1";
import H3 from "../shared/html-tags/h3";
import P from "../shared/html-tags/p";
import DIV from "../shared/html-tags/div";
import H4 from "../shared/html-tags/h4";
import { Box } from "@mui/material";
export type Props = {};

const Features: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div className="page features pillarpage">
      <TopMenu selected="features"></TopMenu>

      <div
        className="page-content  bg-top-features bg-top1 "
        style={{
          height: "25.25rem",
          paddingTop: "0.25rem",
          paddingBottom: "0.25rem",
        }}
      >
        <div className="inner-content ">
          <div style={{ position: "relative", width: "100%" }}>
            <Box
              sx={{
                color: "black",
                position: "absolute",
                width: {
                  md: "32rem",
                  xs: "auto",
                },
                height: "18rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
                marginLeft: "2rem",
                marginTop: "4rem",
                backgroundColor: "transparent",
              }}
            >
              <H2
                language="de"
                style={{ marginBlockEnd: "0", fontSize: "1.2rem" }}
              >
                SPSS + Predictive Solutions = PS IMAGO PRO{" "}
              </H2>
              <H1
                language="de"
                style={{ fontSize: "1.75rem", fontWeight: "bold" }}
              >
                Mehr Features zur Datenanalyse
              </H1>
              <BuyNowButton order={"buy"} />
            </Box>
          </div>
        </div>
        <div className="inner-content feature-images">
          <img
            src="/img/features/83-976x500.png"
            alt=""
            style={{ border: "none", maxHeight: "19.5rem" }}
            className="feature-1-image"
          />
          <img
            src="/img/features/82-529x500.png"
            alt=""
            style={{
              border: "none",
              maxHeight: "19.5rem",
              marginLeft: "-6rem",
            }}
            className="feature-2-image"
          />
          <img
            src="/img/features/81-429x500.png"
            alt=""
            style={{ border: "none", maxHeight: "19.5rem" }}
            className="feature-3-image"
          />
        </div>
      </div>

      <FeatureMenu />
      {/* =========================================================================================== */}
      <div className="page-content bg-1">
        <div className="inner-content">
          <P language="de">
            Mit PS IMAGO PRO hebst du deine Datenanalyse auf ein neues Level.
            Diese leistungsstarke Erweiterung bietet spezialisierte Add-Ons, die
            entwickelt wurden, um das volle Potenzial deiner Daten zu entfalten.
          </P>
          <H2 language="de">
            Entdecke die volle Kraft von SPSS mit PS IMAGO PRO
          </H2>
          <P language="de">
            Wir haben mit über 30 SPSS-Partnern und zahlreichen Kunden
            gesprochen, um zu verstehen, welche Funktionen in SPSS Statistics
            fehlen. Aus diesen wertvollen Erkenntnissen und einer intensiven
            Entwicklungsphase ist PS IMAGO PRO entstanden - perfekt abgestimmt
            auf deine Bedürfnisse.
          </P>

          <FeaturesOverview />

          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <BuyNowButton order={"test14days"} />
          </div>
        </div>
      </div>
      {/* =========================================================================================== */}
      <div className="page-content bg-2 features-1-management">
        <div className="inner-content">
          <center>
            <H2 language="de">Effiziente Datenaufbereitung</H2>
          </center>
          <div className="feature-list">
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/1/features-1-multisource-import.png"
                alt="Multi-Source Datenimport"
              />
              <H3 language="de">Multi-Source Datenimport</H3>
              <P language="de">
                Flexibel importieren, unabhängig von der Datenquelle
              </P>
            </button>
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/1/features-1-optimize-data.png"
                alt="Datenoptimierung"
              />
              <H3 language="de">Datenoptimierung</H3>
              <P language="de">
                Datenqualität, Fehlerkorrektur und Lückenfüllung
              </P>
            </button>
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/1/features-1-data-management.png"
                alt="Datenmanagement"
              />
              <H3 language="de">Datenmanagement</H3>
              <P language="de">Transformations- und Aggregationsfunktionen</P>
            </button>
          </div>
        </div>
      </div>
      {/* =========================================================================================== */}
      <div className="page-content bg-1 features-2-analysis">
        <div className="inner-content">
          <center>
            <H2 language="de">Umfassende Datenanalyse</H2>
          </center>
          <div className="feature-list">
            <button
              className="feature-list-item"
              style={{ width: "50%", minWidth: "50%", maxWidth: "50%" }}
            >
              <img
                src="/img/features/2/features-2-statistical-description.png"
                alt="Statistische Beschreibung"
              />
              <H3 language="de">Statistische Beschreibung</H3>
              <P language="de">
                Häufigkeitstabellen, Kreuztabellen und Diagramme
              </P>
            </button>
            <button
              className="feature-list-item"
              style={{ width: "50%", minWidth: "50%", maxWidth: "50%" }}
            >
              <img
                src="/img/features/2/features-2-analyticalgorythms.png"
                alt="Analyse-Algorithmen"
              />
              <H3 language="de">Analyse-Algorithmen</H3>
              <P language="de">
                Normalverteilung, Standardabweichung und Varianz
              </P>
            </button>
          </div>
        </div>
      </div>
      {/* =========================================================================================== */}
      <div className="page-content bg-2 features-3-reporting">
        <div className="inner-content">
          <center>
            <H2 language="de">Klare Ergebnispräsentation</H2>
          </center>
          <div className="feature-list">
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/3/features-3-report-creation.png"
                alt="Professionelle Berichterstellung"
              />
              <H3 language="de">Berichterstellung</H3>
              <P language="de">Umfassende Datenvisualisierungen</P>
            </button>
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/3/features-3-stylish-layouts.png"
                alt="Stilvolle Layouts"
              />
              <H3 language="de">Stilvolle Layouts</H3>
              <P language="de">
                Intuitive Assistenten, um Stile und Layouts zu erstellen.
              </P>
            </button>
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/3/features-3-dashboard-and-document-mode.png"
                alt="Dashboard-Modus"
              />
              <H3 language="de">Dashboard- und Dokument-Modus</H3>
              <P language="de">
                Interaktive Berichte stets auf dem neuesten Stand.
              </P>
            </button>
          </div>
        </div>
      </div>
      {/* =========================================================================================== */}
      <div className="page-content bg-1 features-4-deployment">
        <div className="inner-content">
          <center>
            <H2 language="de">Smarte Verteilung und Verwaltung</H2>
          </center>
          <div className="feature-list">
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/4/features-4-report-creation.png"
                alt="Statistische Berichterstattung"
              />
              <H3 language="de">Berichterstattung</H3>
              <P language="de">Berichte als Website, Präsentation oder PDF.</P>
            </button>
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/4/features-4-edit-and-update.png"
                alt="Bearbeitung und Aktualisierung"
              />
              <H3 language="de">Korrektur und Anpassung</H3>
              <P language="de">Änderungen mühelos umsetzen.</P>
            </button>
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/4/features-4-manage-and-feedback.png"
                alt="Verwaltung analytischer Objekte & Feedback - Alles organisiert!"
              />
              <H3 language="de">Übersicht und Feedback</H3>
              <P language="de">
                Objekte gruppieren oder ändern und Kommentare hinzufügen.
              </P>
            </button>
          </div>
        </div>
      </div>
      {/* =========================================================================================== */}
      <div className="page-content bg-2 features-5-publish">
        <div className="inner-content">
          <center>
            <H2 language="de">
              Dynamische Veröffentlichung und Automatisierung
            </H2>
          </center>
          <div className="feature-list">
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/5/features-5-cloud.png"
                alt="Cloud Anwendung - Verteilung und Veröffentlichung überall zugänglich!"
              />
              <H3 language="de">Cloud Anwendung</H3>
              <P language="de">
                Verteilung und Veröffentlichung überall zugänglich!
              </P>
            </button>
            <button
              className="feature-list-item"
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/5/features-5-autopilot.png"
                alt="Autopilot - Datenanalyse vereinfachen mittels PS IMAGO PRO's Automatisierungstools"
              />
              <H3 language="de">Autopilot</H3>
              <P language="de">Datenanalyse vereinfachen</P>
            </button>
            <button
              className="feature-list-item"
              onClick={() => {
                const element = document.getElementById("data-management");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              style={{ width: "33%", minWidth: "33%", maxWidth: "33%" }}
            >
              <img
                src="/img/features/5/features-5-live-planning.png"
                alt="Live Planung"
              />
              <H3 language="de">Live Planung</H3>
              <P language="de">Flexible und effiziente Produktivität!</P>
            </button>
          </div>
        </div>
      </div>
      {/* =========================================================================================== */}
      <div className="page-content bg-1">
        <div className="inner-content">
          <H2 language="de">Mehr Leistung mit geringeren Kosten</H2>
          <H3 language="de">Warum dies kein Trugschluss ist?</H3>
          <P language="de">
            IBM bietet speziellen Value Added Resellern vergünstigte Konditionen
            für SPSS Statistics, um die Software in innovative Lösungen zu
            integrieren. Diesen Preisvorteil geben wir direkt an dich weiter.
          </P>
          <P language="de">
            Doch PS IMAGO PRO ist mehr als nur SPSS zum besseren Preis: Die
            zusätzlichen Funktionen sparen dir wertvolle Arbeitszeit – und in
            einer Welt, in der Zeit unser wertvollstes Gut ist, bedeutet das
            mehr Effizienz, schnellere Analysen und präzisere Entscheidungen.
          </P>
          {/*
            //Obiger Text ist durch ChatGPT verbesert worden:
            IBM bietet neben SPSS Statistics Endkundenlizenzen spezielle, reduzierte Angebote für
            Value Added Reseller an, um SPSS in neue Lösungen integrieren zu können. Diesen
            Preisvorteil geben wir gerne an unsere Kunden weiter. Die neuen, ergänzenden Funktionen
            von PS IMAGO PRO sparen dir außerdem wertvolle Arbeitszeit. In einer Welt, in der Zeit
            unsere kostbarste Ressource ist, bedeutet das mehr Effizienz und bessere Ergebnisse für
            dich.
          */}

          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <BuyNowButton order="buy" />
          </div>
        </div>
      </div>
      {/* =========================================================================================== */}
      <div className="page-content bg-2">
        <div className="inner-content feature-table-comparison">
          <H2 language="de">Im direkten Vergleich</H2>
          <table className="feature-comparison" cellSpacing={10}>
            <thead>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <H3 language="de">
                    SPSS Statistics
                    <br />
                    (Standalone)
                  </H3>
                </td>
                <td style={{ textAlign: "center" }}>
                  <H3 language="de">
                    PS IMAGO PRO
                    <br />
                    (SPSS Statistics + Predictive Solutions)
                  </H3>
                </td>
              </tr>
            </thead>
            <tbody>
              {/* ---------------------------------------------------------------- */}
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  <H4 language="de">Datenaufbereitung</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">
                    Bietet grundlegende Tools zur Datenbereinigung und
                    Transformation.
                  </DIV>
                </td>
                <td>
                  <DIV language="de">
                    Beschleunigt die Datenaufbereitung erheblich durch spezielle
                    Verfahren und Techniken zur effizienten Handhabung großer
                    Datensätze.
                  </DIV>
                </td>
              </tr>
              {/* ---------------------------------------------------------------- */}
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  <H4 language="de">Datenanalyse</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">
                    Starke Fähigkeiten in grundlegender und fortgeschrittener
                    statistischer Analyse.
                  </DIV>
                </td>
                <td>
                  <DIV language="de">
                    Beinhaltet erweiterte analytische Fähigkeiten mit
                    zusätzlichen, einzigartigen Verfahren für spezifische
                    Analystenbedürfnisse.
                  </DIV>
                </td>
              </tr>
              {/* ---------------------------------------------------------------- */}
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  <H4 language="de">Datenvisualisierung</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">
                    Bietet grundlegende Fähigkeiten zur Erstellung von
                    Diagrammen und Grafiken.
                  </DIV>
                </td>
                <td>
                  <DIV language="de">
                    Umfasst attraktive Visualisierungen, benutzerdefinierte
                    Diagramme und interaktive Dashboards zur Unterstützung von
                    KPI-Entscheidungen.
                  </DIV>
                </td>
              </tr>
              {/* ---------------------------------------------------------------- */}
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  <H4 language="de">Berichterstellung</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">
                    Grundlegende Berichterstellungsoptionen, ohne integrierte
                    Plattform für umfangreiche Berichte.
                  </DIV>
                </td>
                <td>
                  <DIV language="de">
                    Ermöglicht flexible Berichterstellung mit anpassbaren
                    Formaten, Kommentaren und einer universellen Meldeplattform.
                  </DIV>
                </td>
              </tr>
              {/* ---------------------------------------------------------------- */}
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  <H4 language="de">Berichtverteilung</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">
                    Erfordert manuelle Ausführung von Analysen und Berichten.
                  </DIV>
                </td>
                <td>
                  <DIV language="de">
                    Bietet Automatisierung für den gesamten Analyseprozess, von
                    der Datenerfassung bis zur Berichtsveröffentlichung.
                  </DIV>
                </td>
              </tr>
              {/* ---------------------------------------------------------------- */}
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  <H4 language="de">Kollaboration und Teamarbeit</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">
                    Zusammenarbeit erfordert externe Tools zur Dateifreigabe.
                  </DIV>
                </td>
                <td>
                  <DIV language="de">
                    Integrierte Plattform zur Berichtverteilung und
                    Zugriffskontrolle, fördert die Zusammenarbeit im Team.
                  </DIV>
                </td>
              </tr>
              {/* ---------------------------------------------------------------- */}
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  <H4 language="de">Cloud-Unterstützung und Sicherheit</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">
                    Keine integrierte Cloud-Veröffentlichung; erfordert separate
                    Lösungen für Sicherheit und Cloud-Zugriff.
                  </DIV>
                </td>
                <td>
                  <DIV language="de">
                    Sichere Cloud-Veröffentlichung von Berichten mit
                    Zugriffskontrolle und Einhaltung von Sicherheitsrichtlinien.
                  </DIV>
                </td>
              </tr>
              {/* ---------------------------------------------------------------- */}
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  <H4 language="de">Integration und Erweiterung</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">
                    Unterstützung für Erweiterungen (z. B. R und Python), aber
                    keine integrierte Plattform für umfassende
                    Forschungsprozesse.
                  </DIV>
                </td>
                <td>
                  <DIV language="de">
                    Integration mit PS QUAESTIO PRO zur verbesserten Steuerung
                    von Datenerfassung und Berichterstellung, besonders für
                    Umfragedaten.
                  </DIV>
                </td>
              </tr>
              {/* ---------------------------------------------------------------- */}
              <tr>
                <td colSpan={2} style={{ textAlign: "center" }}>
                  <H4 language="de">Benutzerfreundlichkeit</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">
                    Benutzerfreundliche Oberfläche mit einer gewissen Lernkurve
                    für Einsteiger.
                  </DIV>
                </td>
                <td>
                  <DIV language="de">
                    Intuitive und flexible Benutzeroberfläche, die den Zugang
                    und die Anpassung für alle Benutzerniveaus erleichtert.
                  </DIV>
                </td>
              </tr>
              {/* ---------------------------------------------------------------- 
              <tr>
                <td colSpan={2} style={{ textAlign: 'center' }}>
                  <H4 language="de">Kostenersparnis</H4>
                </td>
              </tr>
              <tr>
                <td>
                  <DIV language="de">Rabatte können bei IBM beantragt werden.</DIV>
                </td>
                <td>
                  <DIV language="de">
                    Kostenersparnis von bis zu 30% durch die Nutzung von PS IMAGO PRO.
                  </DIV>
                </td>
              </tr>*/}
            </tbody>
          </table>
        </div>
      </div>
      {/* =========================================================================================== */}
      <div className="page-content bg-1">
        <div className="inner-content">
          <center>
            <BuyNowButton order="buy" />
          </center>
        </div>
      </div>

      <Footer></Footer>
    </div>
  );
};

export default Features;
